import {POPass} from './POPass';

export class POCarPass extends POPass {
  static type = 'CarPass';
  type = POCarPass.type;
}
